import produce from 'immer';

import * as constants from './constants';
import { ClosingLessonModalStore, ClosingLessonModalAction } from './typings';

const initialState: ClosingLessonModalStore = {
    isOpened: false,
};

const closingLessonModalReducer = (state: ClosingLessonModalStore = initialState, action: ClosingLessonModalAction) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.TOGGLE_MODAL:
                draft.isOpened = action.shouldOpen;
                break;

            default:
                break;
        }
    });
};

export default closingLessonModalReducer;
